import { useEffect, useRef } from 'react';
import { getSocket, onSocketJoin, resetSocket } from '../services/api/gamesApi';

/**
 * Registers the user as online and reports which screen/game they are on.
 */
export function usePresence({ enabled = false, game = 'dashboard' }) {
  const gameRef = useRef(game);
  gameRef.current = game;

  useEffect(() => {
    if (!enabled) {
      resetSocket();
      return undefined;
    }

    const cleanup = onSocketJoin((socket) => {
      socket.emit('join:presence', { game: gameRef.current });
    });

    const socket = getSocket();
    const register = () => {
      socket.emit('join:presence', { game: gameRef.current });
    };
    if (socket.connected) register();
    else socket.once('connect', register);

    const heartbeat = window.setInterval(() => {
      if (socket.connected) socket.emit('presence:heartbeat');
    }, 30000);

    return () => {
      cleanup();
      if (socket.connected) socket.emit('leave:presence');
      window.clearInterval(heartbeat);
    };
  }, [enabled]);

  useEffect(() => {
    if (!enabled) return undefined;
    const socket = getSocket();
    const update = () => socket.emit('presence:update', { game });
    if (socket.connected) update();
    else socket.once('connect', update);
    return undefined;
  }, [enabled, game]);
}
